export default {"src":"/_next/static/media/Monitor.d19a0bd6.svg","height":32,"width":32};